import { IdpModel, IdpProtocol, IdpSettingsModel, IdpType } from '../../../models';
import { OauthModel, OauthDiscoverSettingsModel } from './oauth/sso-oauth.model';
import { OktaModel } from './okta/sso-okta.model';
import { SamlModel, SamlSettingsModel } from './saml/sso-saml.model';

export interface IdpProtocolToDiscoverSettingsModel extends Record<IdpProtocol, IdpSettingsModel> {
  [IdpProtocol.Saml]: SamlSettingsModel;
  [IdpProtocol.Oauth]: OauthDiscoverSettingsModel;
}

export function isSamlIdp(idp: IdpModel): idp is SamlModel {
  return idp.protocol === IdpProtocol.Saml && idp.idp === IdpType.Generic;
}

export function isOktaIdp(idp: IdpModel): idp is OktaModel {
  return idp.protocol === IdpProtocol.Saml && idp.idp === IdpType.Okta;
}

export function isOauthIdp(idp: IdpModel): idp is OauthModel {
  return idp.protocol === IdpProtocol.Oauth;
}
